import { Tabs } from '@mui/material'
import { TabProps } from '@mui/material/Tab'
import { TabsProps } from '@mui/material/Tabs'
import { type Location, matchPath, PathMatch, type UIMatch, useLocation, useMatches } from 'react-router-dom'
import { LinkTab } from './LinkTab'

const getMatchingRoute = (matchingRoutes: UIMatch[], location: Location, tabPath: string): PathMatch<string> | null => {
  for (const matchingRoute of matchingRoutes) {
    const possibleLocationMatch = matchPath(matchingRoute.pathname, location.pathname)
    if (possibleLocationMatch !== null) {
      if (possibleLocationMatch.pathname.endsWith(tabPath)) {
        return possibleLocationMatch
      }
    }
  }
  return null
}

export type NavTabProps = Omit<TabsProps, 'value'> & {
  dataTestId?: string
  tabs: Array<
    TabProps & {
      to: string
      dataTestId?: string
    }
  >
}

export const NavTabs = (props: NavTabProps) => {
  const { tabs, dataTestId, ...rest } = props
  const { sx, ...tabsProps } = rest
  const location: Location = useLocation()
  const matchingRoutes = useMatches()

  if (tabs.length === 0) return null

  let selectedTab = tabs[0] // Default to first tab if no match found
  for (const tab of tabs) {
    const matchingRoute = getMatchingRoute(matchingRoutes, location, tab.to)
    if (matchingRoute?.pattern.path) {
      selectedTab = tab
      break
    }
  }

  return (
    <Tabs value={selectedTab} data-testid={dataTestId} sx={{ marginBlockEnd: 'var(--spacing-m)', ...sx }} {...tabsProps}>
      {tabs.map(tab => {
        const { to, dataTestId, ...otherTabProps } = tab
        return <LinkTab {...otherTabProps} key={to} to={to} value={tab} data-testid={dataTestId} />
      })}
    </Tabs>
  )
}
